exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".evaluation h2 {\r\n  color: #6fa798;\r\n}\r\n\r\n.evaluation img {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.evaluation .fields .field {\r\n  width: 80px;\r\n  height: 60px;\r\n  line-height: 60px;\r\n  font-size: 1.8rem;\r\n  background-color: #d0e2dd;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .evaluation .fields .field {\r\n    width: 60px;\r\n    height: 40px;\r\n    line-height: 40px;\r\n    font-size: 1.2rem;\r\n    background-color: #d0e2dd;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .evaluation .fields .field {\r\n    width: 50px;\r\n    height: 30px;\r\n    line-height: 30px;\r\n    font-size: 1rem;\r\n    background-color: #d0e2dd;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/education-and-career/evaluation/evaluation.component.css
// module id = ../../../../../src/app/components/education-and-career/evaluation/evaluation.component.css
// module chunks = main